import * as React from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../../../redux';
import {getFormValues, InjectedFormProps, reduxForm} from 'redux-form';
import {getLocalities, setCurrentLocality} from '../../../../../../redux/actions/localities';
import {currentLocalitySelector, localitiesListSelector} from '../../../../../../redux/selectors/localities';
import {LocalityResponsePayload} from '../../../../../models/api/localityResponsePayload';
import {Forms} from '../../../../../models/forms';
import {CitySearchForm} from './model';
import View from './view';

interface Props {
  onClose?: () => void;
}

const _CityChange: React.FC<Props & InjectedFormProps<CitySearchForm, Props>> = ({onClose}) => {
  const localities = useSelector(localitiesListSelector());
  const currentLocality = useSelector(currentLocalitySelector());
  const values = useSelector(getFormValues(Forms.citySearchForm)) as CitySearchForm;
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (!localities) {
      dispatch(getLocalities());
    }
  }, [localities]);

  const handleChange = (locality: LocalityResponsePayload) => {
    dispatch(setCurrentLocality(locality));
    if (onClose) onClose();
  };

  const list = React.useMemo(() => {
    if (values?.query) {
      return localities?.filter(
        (locality) => (locality?.name?.toLowerCase() ?? '').indexOf(values?.query?.toLowerCase() || '') > -1,
      );
    } else return localities;
  }, [localities, values]);

  return (
    <View
      onClose={onClose}
      onChange={handleChange}
      list={list ?? null}
      cityName={currentLocality?.name ?? ''}
      currentCityId={currentLocality?.id ?? 0}
    />
  );
};

export const CityChange = reduxForm<CitySearchForm, Props>({form: Forms.citySearchForm})(_CityChange);
